export default {
domainInvalid: {
  siteUnavailableTitle: "Laman Tidak Tersedia",
  siteUnavailableDesc: "Laman ini tidak tersedia buat masa ini.",
  contactAdmin: "Sila hubungi pentadbir.",
  serverErrorTitle: "Perkhidmatan Tidak Tersedia",
  serverErrorDesc: "Gagal menghubungi pelayan, sila cuba lagi kemudian.",
  serverErrorTip: "Sambungan akan disambung semula secara automatik apabila pelayan pulih.",
  notAuthorizedTitle: "Domain Tidak Dibenarkan",
  notAuthorizedDesc: "Domain semasa tidak dibenarkan untuk mengakses perkhidmatan ini.",
  checking: "Menyemak...",
  retry: "Cuba lagi",
  reload: "Muat semula",
  reloading: "Memuat semula...",
  checkingDomain: "Menyemak domain...",
  authorizedRedirecting: "Domain dibenarkan, mengalih...",
  stillNotAuthorized: "Domain masih belum dibenarkan",
  reconnecting: "Menyambung semula..."
}
};
